import {RoleListItem} from '../../../../../Services/user';
import {FlexBox} from '../../../../../Components/FlexBox';
import {Dropdown, message} from 'antd';
import {LinkButton} from '../../../../../Features/Buttons/LinkButton';
import {DashOutlined} from '@ant-design/icons';
import {errorMessage, isTrue} from '../../../../../Utils/common';
import useModalHandler from '../../../../../Utils/Hooks/useModalHandler';
import {RoleModal} from '../RoleModal';
import {useConfirmDelete} from '../../../../../Utils/Hooks/useConfirmDelete';
import {changeStatus, deleteRole} from '../../service';
import useAuth from '../../../../../Utils/Hooks/useAuth';

interface RoleMenuItemProps {
    data: RoleListItem;
    onChange(): void;
}

export function RoleMenuItem({data, onChange}: RoleMenuItemProps) {
    const auth = useAuth();
    const roleModal = useModalHandler({component: RoleModal});

    function onSaveOK() {
        roleModal.close();
        onChange();
    }

    async function onChangeStatus() {
        try {
            const newStatus = data.status === '1' ? '0' : '1';
            await changeStatus(data.id, newStatus);
            onChange();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const onDelete = useConfirmDelete(
        async () => {
            await deleteRole(data.id);
            onChange();
        },
        {
            confirmMessage:
                '删除角色后, 已授权的用户角色会自动释放，且被删除的角色不可恢复，确定删除角色？',
        },
    );

    return (
        <FlexBox gap="5px">
            <FlexBox flex={1}>{data.roleName}</FlexBox>

            {isTrue(data.defaultFlag) && (
                <FlexBox fontSize={12} color="#ccc" transform="scale(0.7)">
                    内置角色
                </FlexBox>
            )}

            {data.status === '0' && (
                <FlexBox fontSize={12} color="#ccc" transform="scale(0.7)">
                    已停用
                </FlexBox>
            )}

            <Dropdown
                disabled={isTrue(data.defaultFlag)}
                menu={{
                    items: [
                        {
                            label: '编辑',
                            key: 'edit',
                            onClick: () =>
                                roleModal.open({
                                    onOk: onSaveOK,
                                    initialValues: data,
                                }),
                            disabled: !auth('SF_J476Zfxw35'),
                        },
                        {
                            label: data.status === '0' ? '启用' : '停用',
                            key: 'stop',
                            onClick: onChangeStatus,
                            disabled: !auth('SF_J476Zfxw37'),
                        },
                        {
                            label: '删除',
                            key: 'delete',
                            onClick: onDelete,
                            disabled: !auth('SF_J476Zfxw38'),
                        },
                    ],
                }}>
                <LinkButton icon={<DashOutlined />} />
            </Dropdown>

            {roleModal.render()}
        </FlexBox>
    );
}
